/**
 * Chart utility functions for ECharts configuration
 */

/** Maximum characters for chart axis labels before truncating with ellipsis */
export const MAX_CHART_LABEL_LENGTH = 30;

/**
 * Truncates a label if it exceeds the maximum length.
 * Aligns with API behavior: coerces null/undefined to empty string, numbers to strings.
 * @param {string|number|null|undefined} label - The label to truncate
 * @param {number} maxLength - Maximum allowed length (default: MAX_CHART_LABEL_LENGTH)
 * @returns {string} Truncated label with ellipsis if needed
 */
export const truncateLabel = (label, maxLength = MAX_CHART_LABEL_LENGTH) => {
  if (label === null || label === undefined) return '';
  const str = String(label);
  if (str.length <= maxLength) return str;
  return `${str.substring(0, maxLength - 3)}...`;
};
